import { SVGProps } from 'react';

const PinScaleSmallAppearanceOutlinedCrossedTrue = (props: SVGProps<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M5.66663 5.92272H3.51933L2.42632 7.01573L8.98437 13.5738L10.0774 12.4808L10.0774 10.3333M7.89137 4.82971L8.98438 3.7367L8.43787 2.09719L9.53088 1.00418L14.9959 6.46923L13.9029 7.56224L12.2634 7.01573L11.1704 8.10874M1.33316 14.6664L5.15869 10.8408M0.666504 0.666656L15.3332 15.3333"
            stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
            strokeWidth={1.33333}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default PinScaleSmallAppearanceOutlinedCrossedTrue;
